import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "../../syntax/index.js";
import { Converter, Unit } from "../../unit/index.js";
import { Dimension } from "./dimension.js";
const { map, either } = Parser;
/**
 * {@link https://drafts.csswg.org/css-values/#lengths}
 *
 * @public
 */
export class Length extends Dimension {
    static of(value, unit) {
        return new Length(value, unit);
    }
    constructor(value, unit) {
        super(value, unit, "length");
    }
    hasUnit(unit) {
        return this._unit === unit;
    }
    withUnit(unit) {
        if (this.hasUnit(unit)) {
            return this;
        }
        if (Unit.isAbsoluteLength(unit) && Unit.isAbsoluteLength(this._unit)) {
            return Length.of(Converter.length(this._value, this._unit, unit), unit);
        }
        throw new Error(`Cannot convert ${this._unit} to ${unit}`);
    }
    isRelative() {
        return Unit.isRelativeLength(this._unit);
    }
    scale(factor) {
        return new Length(this._value * factor, this._unit);
    }
    equals(value) {
        return (value instanceof Length &&
            super.equals(value) &&
            value._unit === this._unit);
    }
    hash(hash) {
        super.hash(hash);
        hash.writeString(this._unit);
    }
    toJSON() {
        return super.toJSON();
    }
    toString() {
        return `${this._value}${this._unit}`;
    }
}
/**
 * @public
 */
(function (Length) {
    function isLength(value) {
        return value instanceof Length;
    }
    Length.isLength = isLength;
    /**
     * {@link https://drafts.csswg.org/css-values/#lengths}
     */
    Length.parse = either(map(Token.parseDimension((dimension) => Unit.isLength(dimension.unit)), (dimension) => Length.of(dimension.value, dimension.unit)), map(Token.parseNumber((number) => number.isInteger && number.value === 0), () => Length.of(0, Unit.Length.Canonical)));
})(Length || (Length = {}));
//# sourceMappingURL=length.js.map